/**
 * View transition names must be unique on the page, and two lead flows can
 * share step ids, so a step's panel is named after its block and its step. A
 * duplicate name would abort the transition.
 */
function getPanelTransitionName(blockKey: string, stepId: string): string {
  return `lead-flow-panel-${blockKey}-${stepId}`.replace(/[^\w-]/g, "-");
}

export { getPanelTransitionName };
